<template>
  <div class="head-container">
    <div class="head-left">
      <el-image :src="require('@/assets/image/header/logo.png')"></el-image>
    </div>
    <div class="head-right">
      <el-menu
        :default-active="$route.matched[1].path"
        mode="horizontal"
        @select="handleSelect"
        menu-trigger="hover"
        :router="true"
        id="head"
      >
        <el-menu-item index="/index">首页</el-menu-item>
        <el-submenu index="2">
          <template slot="title">新能源</template>
          <el-menu-item index="/xny/gfdz">光伏电站</el-menu-item>
          <el-menu-item index="/xny/zhny">综合能源</el-menu-item>
          <el-menu-item index="/xny/wdw">微电网集成</el-menu-item>
          <el-menu-item index="/xny/fgcc">微电网储能逆变一体柜</el-menu-item>
          <!-- <el-menu-item
            @click="navigateTo('http://www.jshcxh.com/hcpv', '_blank')"
            >华成光伏</el-menu-item
          > -->
        </el-submenu>
        <el-submenu index="3">
          <template slot="title">机器人</template>
          <el-menu-item index="/robot/robot-1"
            >电力导轨式巡检机器人</el-menu-item
          >
          <!-- <el-menu-item index="/robot/robot-2">电力轮式巡检机器人</el-menu-item> -->
          <el-menu-item index="/robot/robot-3"
            >架空地线断股修复机器人</el-menu-item
          >
          <el-menu-item index="/robot/robot-4"
            >输电线路绝缘子清洗、喷涂机器人</el-menu-item
          >
          <el-menu-item index="/robot/robot-5"
            >架空裸导线绝缘涂覆机器人</el-menu-item
          >
          <el-menu-item index="/robot/robot-6"
            >巡检机器人监控管理系统</el-menu-item
          >
        </el-submenu>
        <el-submenu index="4">
          <template slot="title">智慧监测</template>
          <el-menu-item index="/zhjc/pdzf">配电站房精益化管理</el-menu-item>
          <el-menu-item index="/zhjc/gydl">高压电缆精益化管理</el-menu-item>
          <el-menu-item index="/zhjc/sdxl">输电线路在线监测装置</el-menu-item>
          <!-- <el-menu-item
            @click="navigateTo('http://www.jshcxh.com/SEEMP', '_blank')"
            >智慧能效</el-menu-item
          > -->
        </el-submenu>
        <el-submenu index="5">
          <template slot="title">智能云仓</template>
          <el-menu-item index="/znyc/wfx">智能危废箱</el-menu-item>
          <el-menu-item index="/znyc/sjxt">智能危废收集云平台</el-menu-item>
        </el-submenu>
        <el-submenu index="6">
          <template slot="title">软件平台</template>
          <el-menu-item index="/rjpt/dljk">电力SCADA监控系统</el-menu-item>
          <el-menu-item index="/rjpt/pdzf">配电站房精益化管理平台</el-menu-item>
          <el-menu-item index="/rjpt/gydl">高压电缆精益化管理平台</el-menu-item>
          <el-menu-item index="/rjpt/dlgl">电力管廊综合监控系统</el-menu-item>
          <el-menu-item index="/rjpt/dlyw"
            >电力运维及智慧能效管理系统</el-menu-item
          >
          <el-menu-item index="/rjpt/tqcn">台区侧储能仿真软件</el-menu-item>
        </el-submenu>
        <el-submenu index="7" popper-class="secondMenu">
          <template slot="title">关于我们</template>
          <el-menu-item index="/about/me">关于华成</el-menu-item>
          <el-menu-item index="/about/news">公司动态</el-menu-item>
        </el-submenu>
      </el-menu>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    }
    // navigateTo(url, target) {
    //   const newWindow = window.open(url, target);
    //   if (newWindow) {
    //     newWindow.opener = null;
    //   }
    // }
  },
  mounted() {}
};
</script>

<style lang="scss" scoped>
.head-container {
  width: 100%;
  height: 60px;
  background-size: 100% 100%;
  overflow: hidden;
  position: relative;

  .head-left {
    float: left;
    height: 60px;
    margin-left: 10vw;
    .el-image {
      position: relative;
      top: 50%;
      transform: translateY(-50%);
    }
  }

  .head-right {
    height: 60px;
    position: absolute;
    right: 10vw;
  }
}
</style>
<style lang="scss">
.head-container {
  .el-submenu__title i {
    color: #fff;
  }
  .el-menu {
    background-color: unset !important;
    .el-menu-item {
      font-size: 18px;
      padding: 0;
      margin: 0 25px;
      background-color: unset !important;
      color: #fff !important;
    }
    .el-submenu > .el-submenu__title {
      font-size: 18px;
      color: #fff;
      margin: 0 25px;
      padding: 0;
      &:hover {
        background-color: unset;
      }
    }
  }
}
.el-menu--horizontal > .el-submenu .el-submenu__icon-arrow {
  display: none;
}
.el-menu--horizontal .el-menu .el-menu-item {
  padding: 0 24px !important;
  font-size: 16px;
}
.el-menu--horizontal.secondMenu .el-menu--popup {
  min-width: 140px !important;
}
.el-menu--horizontal.secondMenu .el-menu .el-menu-item {
  padding: 0 24px !important;
}
.el-icon-arrow-down:before {
  content: "";
}
</style>



// WEBPACK FOOTER //
// src/views/public/header.vue